import ServiceError from '../../core/errors/ServiceError';
import { getDayNumber } from '../../utils/urlUtils';

export default async function loadServiceVideoProducer(url) {
  if (!url) {
    return new ServiceError('No hay url para servicio de VideoProducer', '00113');
  }
  const urlWithCache = `${url}?cache=${getDayNumber()}`;
  const response = await fetch(urlWithCache, {
    method: 'GET',
  });
  let json;
  try {
    json = await response.json();
  } catch (error) {
    if (response?.status === 204) {
      return new ServiceError(
        'No hay contenido proporcionado por el servicio de VideoProducer',
        '00112',
      );
    }
    return new ServiceError('No se ha podido cargar el servicio de VideoProducer', '00111');
  }
  return json;
}
